import { useEffect, useState } from "react";

import { reloadPage } from "@/lib/reloadPage";

/** 正常第一次載入約 3–5 秒；超過 10 秒通常是請求卡住，給使用者重新載入的出口。 */
export const LOADING_TIMEOUT_MS = 10_000;

/**
 * 放在「正在載入」畫面裡：逾時前不顯示；逾時後出現提示與重新載入按鈕。
 * 不中斷原本的等待，請求晚一點回來頁面仍會正常出現。
 */
export function LoadingTimeoutNotice() {
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setTimedOut(true), LOADING_TIMEOUT_MS);
    return () => window.clearTimeout(timer);
  }, []);

  if (!timedOut) {
    return null;
  }

  return (
    <div role="alert" className="flex flex-col items-center gap-3 text-center">
      <p className="text-sm text-ink-muted">載入時間比平常久，可能是網路不穩。</p>
      <button
        type="button"
        onClick={reloadPage}
        className="rounded bg-action px-4 py-2 text-sm text-white hover:bg-action-hover"
      >
        重新載入
      </button>
    </div>
  );
}
